export default __webpack_public_path__ + "static/media/plus.7e599da6.png";